function sum(arr) {
	return arr.reduce((a, b) => a + b, 0);
}

let startScore = 0;

export function currentScore(history1) {
	let history = history1.filter(hr => hr.type);
	
	let tasks = [...new Set(history.map((hr) => hr.minigame.name))];
	let scoreArray = tasks.map((name) => Math.max(...history.filter(({minigame}) => minigame.name === name).map(hr => hr.score)));
	let advices = sum(history1.filter(hr => !hr.type).map(hr => hr.score));
	let nonLimitScore = sum(scoreArray) + startScore + advices;
	return nonLimitScore > 0 ? nonLimitScore : 0;
}

export function maxAvailableScore(history) {
	let tasks = [...new Set(history.map(({minigame}) => minigame.name))];
	let scoreArray = tasks.map((name) => Math.max(...history.filter(({minigame}) => minigame.name === name).map(({ score, maxScore = typeof score === 'number' ? score : 0 }) => maxScore)));
	return sum(scoreArray) + startScore;
}

export function calcScore(minigame, playerAns){
	if(minigame.form.type === "AutoFinish"){
		return 0;
	}
	switch(minigame.minigameType){
		case "Question": {
			return getQuestionScore(minigame, playerAns);
		}
		case "ManyAnsQuestion": {
			return getManyAnsQuestionScore(minigame, playerAns);
		}
		case "Greeting":
		case "Final":
		case "End":
		case "Comics":
		case "Intro": {
			return 0;
		}
		default: {
			return minigame.isCompleted(minigame.form, playerAns) ? 1 : 0;
		}
	}
}

export function calcMaxScore(minigame, playerAns){
	if(minigame.form.type === "AutoFinish"){
		return 0;
	}
	switch(minigame.minigameType){
		case "Question": {
			return getQuestionMaxScore(minigame, playerAns);
		}
		case "ManyAnsQuestion": {
			return getManyAnsQuestionMaxScore(minigame, playerAns);
		}
		case "Greeting":
		case "Final":
		case "End":
		case "Comics":
		case "Intro": {
			return 0;
		}
		default: {
			return 1;
		}
	}
}

function getQuestionScore(minigame, playerAns){
	let minigameResult = minigame.isCompleted(minigame.form, playerAns);
	let scores;
	if(minigame.form.scores){
		scores = [minigame.form.scores[playerAns]];
	}
	else if(minigame.scores){
		scores = [minigame.scores];
	}
	else {
		return 0;
	}

	if(minigameResult){
		if(minigame.EstPos){
			return getFinalScore(scores, minigame.EstPos);
		}
		else {
			return getFinalScore(scores, "max");
		}
	}
	else {
		if(minigame.EstNeg){
			return getFinalScore(scores, minigame.EstNeg);
		}
		else {
			return getFinalScore(scores, "neg");
		}
	}
}

function getFinalScore(scores, mode){
	const sumReducer = (accumulator, currentValue) => accumulator + currentValue;
	switch(mode){
		default:
		case "max": {
			return Math.max(...scores);
		}
		case "min": {
			return Math.min(...scores);
		}
		case "sum": {
			return scores.reduce(sumReducer, 0);
		}
		case "neg": {
			return Math.max(...scores);
		}
		case "zero": {
			return 0;
		}
		case "fatal": {
			return -10000;
		}
		
	}
}

function getManyAnsQuestionScore(minigame, playerAns){
	
	let minigameResult = getFullRes(minigame.form, playerAns);
	let playerScores = [];
	if(minigame.form.scores){
		playerScores = playerAns.map(elem => minigame.form.scores[elem]);
	}
	else if(minigame.scores){
		playerScores = minigame.variants.filter();
	}
	else {
		console.warn("Счет вопроса не задан");
		return 0;
	}
	switch(minigameResult){
		case 1: {
			if(minigame.EstPos){
				return getFinalScore(playerScores, minigame.EstPos);
			}
			else {
				return getFinalScore(playerScores, "sum");
			}
		}
		case 2: {
			if(minigame.EstMix){
				return getFinalScore(playerScores, minigame.EstMix);
			}
			else {
				return getFinalScore(playerScores, "min");
			}
		}
		case 3: {
			if(minigame.EstMix){
				return getFinalScore(playerScores, minigame.EstMix);
			}
			else {
				return getFinalScore(playerScores, "min");
			}
		}
		case 4: {
			return getFinalScore(minigame.form.scores, "min");
		}
		default: {
			return 0;
		}

	}
}

function getFullRes({options, correct}, indices){
	//Full right answer
	if(indices.length === correct.length && (indices.every(i => correct.indexOf(i) !== -1))){
		return 1;
	}
	//Partial right answer
	else if(indices.some(i => correct.indexOf(i) !== -1)){
		return 2
	}
	//Full wrong non-empty answer
	else if(indices.length > 0) {
		return 3;
	}
	else {
		return 4;
	}
}

function getQuestionMaxScore(minigame) {
	if(minigame.form.scores){
		return minigame.form.scores[minigame.form.correct];
	}
	else if(minigame.scores){
		return minigame.scores;
	}
	else {
		return 0;
	}
}

function getManyAnsQuestionMaxScore(minigame){
	let scores = [];
	if(minigame.form.scores){
		scores = minigame.form.scores.filter((elem, index) => minigame.form.correct.indexOf(index) !== -1);
	}
	else if(minigame.scores){
		scores = minigame.variants.map((elem, index) => minigame.form.correct.indexOf(index) !== -1 ? minigame.scores: 0);
	}
	else {
		return 0;
	}
	if(minigame.EstPos){
		return getFinalScore(scores, minigame.EstPos);
	}
	else {
		return getFinalScore(scores, "sum");
	}
}

